module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAqCAYAAADxughHAAAAAXNSR0IArs4c6QAAANZJREFUaAXt17ENwkAMhWHfKRUbsAFTIHpERYVEzwYMwQb0SFRUiD5iimzABlSRkzNHmQJFp1MO/SmjxH7+XFnkTx5nc6w2u0Wn7bLEmZyvnvX92lQW3oZQ1XOJg3hpDyF340sMP5T5sxFbz3eyoW8m/c6yTzog4RBAAAEEEEAAAQQQSC4QL8T1dq8qp+TVMxT0Xo7143aJF6L4WSc6z9A3eYsuZLei8bASfYfVvJJ3yVDQhewZ2tACAQQQQAABBBBAAAEE0gtwIaY3HVeRC3GcG3/9LNAD1L00GOV+i/cAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/side-hamburger.png
// module id = nFOR
// module chunks = 1